import React from 'react';
import cx from 'classnames';
import ReactFormControlLabel from '@material-ui/core/FormControlLabel';
import ReactCheckbox from '@material-ui/core/Checkbox';
import { FocusBox } from '../../theme/focus';
import * as componentStyling from '../styling';

const Checkbox = React.memo(({label, ...props}) =>{
	return (
		<FocusBox>
			<ReactFormControlLabel 
				label={label}
				control={<ReactCheckbox {...props} />} 
				className={cx(componentStyling.Control)}
				/>
		</FocusBox>
	);
});

export default Checkbox;